<template>
  <popup
    v-if="isManager('project|maintenance|finance|management|admin')"
    button-style="primary"
    heading="New Sharer"
    :show-text="showText"
    button-text="Sharer"
    size="medium"
    button-icon="fa fa-plus"
    :disable-button="!isManager('project|finance') || readOnly"
    :before-save="beforeSave"
    @save="onSaveDialog"
    @close="onCloseDialog">

    <div class="padded" style="clear: both; text-align: left;">

    <el-row justify="start" align="middle">
    <el-form ref='licenseeForm' v-model="telco" label-position="top">
      <el-row :gutter="8">

        <el-col :sm="24" :md="12">
          <select-sharer :size="size" v-model="telco.organisation_id" placeholder="Select Sharer" requried />
        </el-col>

        <el-col :sm="24" :md="12" :lg="6">
            <text-input label="Their Site ID"  :size="size" v-model='telco.telcoSiteId' />
        </el-col>

     </el-row>


       <el-row :gutter="8">

        <el-col :sm="24" :md="12">
          <select-service-type  :size="size" v-model="telco.serviceType" />
        </el-col>

        <el-col :sm="24" :md="12">
          <select-spectrum   :size="size" v-model="telco.spectrumBand" />
        </el-col>

      </el-row>

      <el-row :gutter="8">
        <el-col :sm="24">
          <sharer-rate-override
            v-model="telco.rate_id"
            :sharer-id="telco.organisation_id"
            :disabled="readOnly || !telco.organisation_id" />
        </el-col>
      </el-row>

      <!-- XOL-467: any-to-all auto-fill notice. Source-agnostic copy — any of
           Handover/Agreement Start/Billing Start can be the field the user
           actually typed. -->
      <el-row v-if="autoFilled" :gutter="8">
        <el-col :sm="24">
          <el-alert type="info" show-icon :closable="false"
            description="Any dates that were still blank have been filled in from the date you just set. Adjust them if they differ." />
        </el-col>
      </el-row>

      <el-row :gutter="8">
        <el-col :sm="24" :md="12" :lg="12">
          <el-form-item label='Handover Date' class="licensee-date--editing" :error="fieldErrors.handover">
            <el-date-picker ref="dateField_handover" value-format="yyyy-MM-dd" :format="format" :size="size"
            v-model="telco.handover" @change="onDateChange('handover', $event)" />
          </el-form-item>
        </el-col>

        <el-col :sm="24" :md="12" :lg="12">
          <el-form-item label='Agreement Start' class="licensee-date--editing" :error="fieldErrors.started">
            <el-date-picker ref="dateField_started" value-format="yyyy-MM-dd" :format="format" :size="size"
            v-model="telco.started" @change="onDateChange('started', $event)" />
          </el-form-item>
        </el-col>

        <!-- XOL-467: Billing Start, previously not collected on create at all.
             Left blank the API derives it from the commencement date (or the
             handover when that is blank too) — deriving is the fallback, not the
             intent. -->
        <el-col :sm="24" :md="12" :lg="12">
          <el-form-item label='Billing Start' class="licensee-date--editing" :error="fieldErrors.startBilling">
            <el-date-picker ref="dateField_startBilling" value-format="yyyy-MM-dd" :format="format" :size="size"
            v-model="telco.startBilling" @change="onDateChange('startBilling', $event)" />
          </el-form-item>
        </el-col>

        <el-col :sm="24" :md="12" :lg="12">
          <el-form-item label='On Air Date' class="licensee-date--editing">
            <el-date-picker value-format="yyyy-MM-dd" :format="format" :size="size"
            v-model="telco.onAir" @change="clearDateErrors" />
          </el-form-item>
        </el-col>

        <el-col :sm="24" :md="12" :lg="12">
          <el-form-item label='Expiry Date' class="licensee-date--editing" :error="fieldErrors.expiry">
            <el-date-picker ref="dateField_expiry" value-format="yyyy-MM-dd" :format="format" :size="size"
            label='Contract End' v-model='expiryDate' disabled />
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="8">
        <el-col :md="24" :lg="10">
          <el-form-item label='Tenor (years)'>
            <el-slider :size="size"
            v-model="tenor" :min="1" :max="20" show-stops show-input>
          </el-slider>
        </el-form-item>
        </el-col>

        <el-col :sm="24" :md="12" :lg="6" :offset="2"> <!-- BUG: need to change to add equipment -->
          <number-input label="Cabins" :size="size" :min="0" :max="10" v-model="telco.cabin" />
        </el-col>

      <el-col :sm="24" :md="12" :lg="6"> <!-- BUG: need to change to add equipment -->
         <check-box :label="'Own ' + utilLabel + ' Meter'" v-model="telco.ownMeter" />
       </el-col>

      </el-row>

      <el-row v-if="canAccess('finance')" :gutter="8">
        <el-col :sm="24" :md="12" :lg="4">
          <float-input label="Sharer Specific CAPEX" placeholder="CAPEX" :size="size" v-model='telco.capex' />
        </el-col>

        <el-col :sm="24" :md="12" :lg="4">
          <float-input label="Sharer Specific OPEX" placeholder="OPEX" :size="size" v-model='telco.opex' />
        </el-col>
      </el-row>


    </el-form>
  </el-row>

</div>

  </popup>

</template>



<script>

import {settings} from '@/components/Data'

import PostMixins from '@/mixins/PostMixins'
import DateMixins from '@/mixins/DateMixins'
import DateChainMixin from '@/mixins/DateChainMixin'
import {dateChainErrors, autoFillDates} from '@/lib/licenseeDates'

import SelectSharer from '@/components/atoms/selects/SelectSharer'
import SharerRateOverride from '@/components/finance/rates/SharerRateOverride'

// XOL-467 (any-to-all widening): the three fields this dialog can both source
// and target auto-fill from/to. See licenseeDates.js's autoFillDates() doc.
var DATE_CHAIN_FIELDS = ['handover', 'started', 'startBilling']

export default {

  mixins: [DateMixins, PostMixins, DateChainMixin],

  components: {
    SelectSharer,
    SharerRateOverride
  },

  props: {

    rowData: {
      type: Object,
      required: true
    },

    showText: {
      type: Boolean,
      default: true
    },

    siteId: {
      type: [String, Number],
      default: null
    },

    tableRef: {
      type: String,
      default: 'telcotable'
    },

    readOnly: {
      type: Boolean,
      default: false
    }

  },

  methods: {
    // Pushes posts to the server when called.
    resetData () {
      this.telco = this.getTableStruct('licensees')
      this.telco.site_id = this.siteId ? this.siteId : this.rowData.site_id
      this.autoFilled = false
    },

    // XOL-467: field -> message for `dateChainErrors()`. Every chain field
    // has an input on this form, so nothing needs rerouting.
    dateChainCopy (item) {
      switch (item.code) {
        case 'handover_required':
          return {field: 'handover', message: 'Required when Agreement Start is set.'}
        case 'started_required':
          return {field: 'started', message: 'Required when Billing Start is set.'}
        case 'billing_start_required':
          return {field: 'startBilling', message: 'Required when Agreement Start is set.'}
        case 'billing_before_started':
          return {
            field: 'startBilling',
            message: 'Cannot be before Agreement Start (' + this.formatDate(this.telco.started) + ').'
          }
        case 'expiry_before_billing_start':
          return {field: 'expiry', message: 'Must be after Billing Start.'}
        default:
          return null
      }
    },

    // XOL-467: `Popup.saveModal` gates on `!this.beforeSave()` — a plain
    // synchronous boolean, unlike Element's own validate() (which this stack
    // cannot use: `v-model="telco"`, not `:model`, leaves `this.model`
    // undefined, and a returned Promise always coerces truthy through `!`).
    beforeSave () {
      var self = this
      // XOL-483: `true` — this popup only ever POSTs (see onSaveDialog/
      // saveForm), so it must judge the row the API's create-time cascade
      // produces, not the raw form values. See licenseeDates.js's own
      // docblock.
      var errors = dateChainErrors(this.telco, true)
      var map = {}

      errors.forEach(function (item) {
        var copy = self.dateChainCopy(item)
        if (copy && !map[copy.field]) {
          map[copy.field] = copy.message
        }
      })

      this.fieldErrors = map

      var fields = Object.keys(map)
      if (fields.length > 0) {
        this.notifyBlockedSave(fields.length)
        this.focusDateField(fields[0])
        return false
      }

      return true
    },

    // Errors clear on ANY date change — the whole map, since the rules are
    // cross-field. Every chain field's change also checks for any-to-all
    // auto-fill (XOL-467).
    onDateChange (field, value) {
      this.clearDateErrors()
      this.maybeAutoFillDates(field, value)
    },

    // XOL-467 (any-to-all widening): any of Handover/Agreement Start/Billing
    // Start can be the source. Fills each of the other two that is still empty; a value you typed is never a target
    // before this edit — the same gate doubles as the "do not fight the
    // user" re-arm condition (see autoFillDates()'s own doc in
    // licenseeDates.js). An already-filled row is never touched.
    maybeAutoFillDates (field, value) {
      var updates = autoFillDates(this.telco, field, value, DATE_CHAIN_FIELDS)
      var keys = Object.keys(updates)
      if (keys.length === 0) return

      var self = this
      keys.forEach(function (key) { self.telco[key] = updates[key] })
      this.autoFilled = true
    },

    onSaveDialog () {
      this.telco.site_id = this.siteId ? this.siteId : this.rowData.id

      if (this.telco.started === 'invalid date') {
        this.telco.started = null
      }

      if (this.telco.expiry === 'invalid date') {
        this.telco.expiry = null
      }

      this.telco.outdoor = !this.telco.cabin

      this.telco.started = this.formatDateSql(this.telco.started)
      this.telco.expiry = this.formatDateSql(this.telco.expiry)
      this.telco.handover = this.formatDateSql(this.telco.handover)
      this.telco.startBilling = this.formatDateSql(this.telco.startBilling)
      this.telco.onAir = this.formatDateSql(this.telco.onAir)

      this.refreshStats(this.telco.site_id)

      this.saveForm(this, '/licensees', this.telco.id, this.telco, 'Sharer', this.success)
      this.$emit('update-stats')
    },

    onCloseDialog () {
      this.resetData()
      this.clearDateErrors()
      this.$emit('update-stats')
    },

    success () {

      if (this.telco.cabin > 0) {
        let cabinAsset = {}
        cabinAsset.owner_id = this.telco.organisation_id
        cabinAsset.site_id = this.telco.site_id
        cabinAsset.category = 'Buildings'
        cabinAsset.type = 'Cabin'
        cabinAsset.qty = this.telco.cabin
        cabinAsset.isAuditable = true
        cabinAsset.usesPower = true

        this.saveForm(this, '/assets', null, cabinAsset, 'Cabins', null, null, false)
      }


      if (this.telco.ownMeter) {
        let meterAsset = {}
        meterAsset.owner_id = this.telco.organisation_id
        meterAsset.site_id = this.telco.site_id
        meterAsset.category = 'Power'
        meterAsset.type = 'Own Meter'
        meterAsset.qty = 1
        meterAsset.isAuditable = false
        meterAsset.providesPower = true
        meterAsset.usesPower = false

        this.saveForm(this, '/assets', null, meterAsset, 'Own Meter', null, null, false)
      }

      this.$events.emit(this.tableRef + '-refresh-table')
      this.resetData()
    }
  },

  computed: {
    expiryDate: function () {
      this.telco.expiry = this.contractExpiryDate(this.telco.started, this.tenor, 'years', 'YYYY-MM-DD')
      return this.telco.expiry
    }
  },

  data () {
    return {
      utilLabel: this.getUtilLabel(this.rowData),
      format: settings.selectDateFormat,
      size: this.isSmall ? 'medium' : 'large',
      tenor: 10,
      telco: this.getTableStruct('licensees'),
      // XOL-467: any-to-all auto-fill notice flag — see maybeAutoFillDates().
      autoFilled: false
    }
  } // data

}

</script>

<style scoped>
/* XOL-467: reserve room for the absolutely-positioned .el-form-item__error so
   a blocked-save message can never overlap the Tenor/Cabins row below.
   Scoped to this custom class only (not a bare ::v-deep .el-form-item rule —
   that leaks into every nested form, XOL-451). */
.licensee-date--editing {
  margin-bottom: 56px !important;
}

.licensee-date--editing ::v-deep .el-form-item__error {
  line-height: 1.4;
}
</style>
